import React from 'react';
import ReactDOM from 'react-dom/client'
import App from './App';
import { ConfirmContextProvider } from "./store/confirmation/ConfirmContextProvider";
import ConfirmDialog from "./components/confirmDialog/ConfirmDialog";
import AppProvider from './Providers';

import { createTheme, MantineProvider } from "@mantine/core";
import { NavigationProgress } from "@mantine/nprogress";
import { Notifications } from "@mantine/notifications";
import { mantineThemOptions } from './Constants';

const theme = createTheme(mantineThemOptions);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<MantineProvider theme={theme} defaultColorScheme="light">
			<NavigationProgress />
			<AppProvider>
				<ConfirmContextProvider>
					<App />
					<ConfirmDialog />
				</ConfirmContextProvider>
			</AppProvider>
			<Notifications />
		</MantineProvider>
	</React.StrictMode>,
);
